import SAApi from './_saApi';
import httpClient from '@/apis/base/httpclient';

class SASaleInvoiceReferenceAPI extends SAApi {
  constructor() {
    super();
  }
  controllerName = 'SASaleInvoiceReferences';

  /**
   * Kiểm tra hóa đơn đã lập chứng từ bán hàng chưa
   * @param {*} payload
   * @returns
   * TTLONG 15/09/2022
   */
  async checkMakeSalesVouchers(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/exists-invoice?sASaleInvoiceId=${payload}`,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy số chứng từ bán hàng
   * @param {*} payload
   * @returns
   * TTLONG 15/09/2022
   */
  async getSaleVoucherNo(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/getSaleVoucherNo?sASaleInvoice=${payload}`,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy ngày hệ thống
   * @returns
   * TTLONG 20/09/2022
   */
  async getSystemDate() {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/getSystemDate`,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Xóa dữ liệu
   * @returns
   * TTLONG 20/09/2022
   */
  async deteleReferenceBySASaleInvoiceId(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/deteleReference/${payload}`,
    };

    return await httpClient.deleteAsync(request);
  }
}

export default new SASaleInvoiceReferenceAPI();
